import { format } from "date-fns";
import { id } from "date-fns/locale";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { Button } from "./ui/button";
import { CalendarBlank } from "@phosphor-icons/react";

export const DatePickerID = ({ value, onChange, placeholder = "Pilih tanggal", testId, disabled }) => {
  const date = value ? new Date(`${value}T00:00:00`) : undefined;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" data-testid={testId}
          className="w-full justify-start rounded-none font-normal h-9 px-3">
          <CalendarBlank size={15} className="mr-2 text-muted-foreground shrink-0" />
          {date ? format(date, "d MMMM yyyy", { locale: id }) : <span className="text-muted-foreground">{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={date} defaultMonth={date} locale={id} disabled={disabled}
          onSelect={(d) => d && onChange(format(d, "yyyy-MM-dd"))} />
      </PopoverContent>
    </Popover>
  );
};
